import { Mail, MailOpen, MoreVertical, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface NotificationItemMenuProps {
  isUnread: boolean;
  notificationId: string;
  onMarkRead: (notificationId: string) => void;
  onMarkUnread: (notificationId: string) => void;
  onDelete: (notificationId: string) => void;
}

export function NotificationItemMenu({
  isUnread,
  notificationId,
  onMarkRead,
  onMarkUnread,
  onDelete,
}: NotificationItemMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="mt-0.5 h-6 w-6 shrink-0 opacity-0 group-hover:opacity-100"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem
          onClick={() => {
            if (isUnread) {
              onMarkRead(notificationId);
            } else {
              onMarkUnread(notificationId);
            }
          }}
        >
          {isUnread ? <MailOpen className="h-4 w-4" /> : <Mail className="h-4 w-4" />}
          {isUnread ? "Mark as read" : "Mark as unread"}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem variant="destructive" onClick={() => onDelete(notificationId)}>
          <Trash2 className="h-4 w-4" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
